// extracted by mini-css-extract-plugin
module.exports = {"Form":"MessageForm_Form__1kRl8"};